export default "__VITE_ASSET__7RFqqOua__"